import { useContext } from 'react';
import Container from 'react-bootstrap/Container';
import { ThemeContext } from '../../../context/theme-context';
import ListaVendasTemporarias from '../../../Components/Vendas/ListaVendasTemporarias';

export default function CadVendasTemporarias() {
  const { collapsed } = useContext(ThemeContext);

  return (
    <Container
      className={collapsed ? 'contenteLayoutCollapsed' : 'contenteLayout'}
    >
      <ListaVendasTemporarias />
    </Container>
  );
}
